import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useEramanPrivilegeFooter } from "../Footer.hook";
import { fields } from "../constants";

export const EramanPrivilege = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useEramanPrivilegeFooter();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    refetchEditData();
  }, [query.get("editId"), query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      field_eraman_title_en: decodeHTML(
        dataById ? dataById.payload.field_eraman_title_en : editData ? editData?.[0]?.field_eraman_title_en : ""
      ),
      field_eraman_title_ms: decodeHTML(
        dataById ? dataById.payload.field_eraman_title_ms : editData ? editData?.[0]?.field_eraman_title_ms : ""
      ),
      field_eraman_title_zh: decodeHTML(
        dataById ? dataById.payload.field_eraman_title_zh : editData ? editData?.[0]?.field_eraman_title_zh : ""
      ),

      field_membership_application_en: decodeHTML(
        dataById
          ? dataById.payload.field_membership_application_en
          : editData
            ? editData?.[0]?.field_membership_application_en
            : ""
      ),
      field_membership_application_ms: decodeHTML(
        dataById
          ? dataById.payload.field_membership_application_ms
          : editData
            ? editData?.[0]?.field_membership_application_ms
            : ""
      ),
      field_membership_application_zh: decodeHTML(
        dataById
          ? dataById.payload.field_membership_application_zh
          : editData
            ? editData?.[0]?.field_membership_application_zh
            : ""
      ),

      field_term_conditions_en: decodeHTML(
        dataById ? dataById.payload.field_term_conditions_en : editData ? editData?.[0]?.field_term_conditions_en : ""
      ),
      field_term_conditions_ms: decodeHTML(
        dataById ? dataById.payload.field_term_conditions_ms : editData ? editData?.[0]?.field_term_conditions_ms : ""
      ),
      field_term_conditions_zh: decodeHTML(
        dataById ? dataById.payload.field_term_conditions_zh : editData ? editData?.[0]?.field_term_conditions_zh : ""
      ),
      field_terms_url: decodeHTML(
        dataById ? dataById.payload.field_terms_url : editData ? editData?.[0]?.field_terms_url : ""
      ),

      field_faq_en: decodeHTML(dataById ? dataById.payload.field_faq_en : editData ? editData?.[0]?.field_faq_en : ""),
      field_faq_ms: decodeHTML(dataById ? dataById.payload.field_faq_ms : editData ? editData?.[0]?.field_faq_ms : ""),
      field_faq_zh: decodeHTML(dataById ? dataById.payload.field_faq_zh : editData ? editData?.[0]?.field_faq_zh : ""),
      field_faq_url: decodeHTML(
        dataById ? dataById.payload.field_faq_url : editData ? editData?.[0]?.field_faq_url : ""
      ),
    },
    fields: fields.eramanPrivilege,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else {
          delete data[key]; // fallback in case of invalid field
        }
      } catch (error) {
        console.error("Image processing failed for:", key, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Footer",
      subModule: `eramanPrivilege`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        ...data,
        publish: true,
      },
      status: status,
    };
    console.log("payload", payload);
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      console.log("payload", payload);
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${eramanHost}/api/eraman-previlage-details/${editData?.[0]?.id || dataById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </>
  );
};
